var map = {
	"./allinc.png": 11660,
	"./allinclusive.png": 33614,
	"./alpereiser.png": 34235,
	"./amisol.png": 2088,
	"./apollo.png": 40058,
	"./lionalpin.png": 93363,
	"./nazar.png": 56919,
	"./norwegianholidays.png": 21442,
	"./sasholidays.png": 1221,
	"./sembo.png": 52945,
	"./solfaktor.png": 65374,
	"./test.png": 18683,
	"./ticket.png": 67655,
	"./tripx.png": 91142,
	"./tui.png": 78263,
	"./ving.png": 9329,
	"./vingdynamic.png": 14616,
	"./vitalreiser.png": 36525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62596;